import { googleZoomLevelToMiles } from 'dash-ui';
import { DashValidation } from 'dash-common';

export type BoundsJsonType = {
  east: number;
  north: number;
  south: number;
  west: number;
};
export const RADIUS = DashValidation.MaxLocationRadius;
export const formatPropertiesMapLocationFilter = (
  filters: Record<string, any>
) => ({
  locationFilter: {
    ...(filters.center && filters.center),
    bounds: filters.bounds as BoundsJsonType,
  },
});

/** create circle area with center on map center */
const getCircleBounds = (map: google.maps.Map) => {
  const center = {
    lat: map.getCenter()?.lat() || 0,
    lng: map.getCenter()?.lng() || 0,
  };
  const centerSfo = new google.maps.LatLng(center.lat, center.lng);
  return new google.maps.Circle({
    // miles to meter
    radius: RADIUS * 1609.34,
    center: centerSfo,
  }).getBounds();
};

/** return QueryBounds or MapBounds base on which is bigger*/
export const getQueryBounds = (
  map: google.maps.Map | null,
  oldBounds: google.maps.LatLngBounds | undefined | null
): google.maps.LatLngBounds | undefined | null => {
  if (!map) return undefined;
  const zoomLevel = map.getZoom();
  const lat = map.getCenter()?.lat() || 0;
  const mapRadius =
    zoomLevel && lat ? googleZoomLevelToMiles(lat, zoomLevel) : 0;
  if (mapRadius > RADIUS) return map.getBounds();
  if (!oldBounds) return getCircleBounds(map);
  const northEast = map.getBounds()?.getNorthEast();
  const southWest = map.getBounds()?.getSouthWest();
  const isContains =
    northEast &&
    southWest &&
    oldBounds?.contains(northEast) &&
    oldBounds?.contains(southWest);
  return isContains ? oldBounds : getCircleBounds(map);
};
